export default __webpack_public_path__ + "static/media/H0001.8fd78758.png";